import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import Conversations from '../components/Conversations';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    conversations: state.conversations,
    business: state.business,
    auth: state.auth,
    staffManagement: state.StaffManagement,
    softwares: state.softwares,
    conversationDetails: state.conversationDetails,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Conversations);
